import React from 'react';
import { useTransferNotificationListener } from '@/hooks/useTransferNotificationListener';

/**
 * Componente invisível que apenas ativa o hook de listener de notificações
 * de transferências via Firestore para a carteira conectada.
 *
 * Deve ser renderizado dentro de `NotificationsProvider` e dos providers
 * de conexão de carteira.
 */
export default function TransferNotificationListener() {
  useTransferNotificationListener();
  return null;
}

